var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.load),expression:"load"}],class:['loading',_vm.loadBg?'bg':'']},[_c('div',{class:[_vm.loadTitle,'loading_warp']},[_c('div',{staticClass:"loading-toast"},[_c('div'),_c('p',[_vm._v(_vm._s(_vm.loadBg?'图片生成中...':'加载中...'))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }